var map = {
	"./alipay.png": "f73b",
	"./car.png": "f55e",
	"./coupon.png": "2c05",
	"./delete.png": "72f1",
	"./down.png": "b265",
	"./head-picture.png": "c005",
	"./inte.png": "9d5a",
	"./return.png": "9bb3",
	"./scroll-top.png": "5097",
	"./service.png": "bfae",
	"./service2.png": "8895",
	"./surplus.png": "5dfb",
	"./tips.png": "6285",
	"./up.png": "a6c1",
	"./wechat.png": "e5d7",
	"./wechatPay.png": "afcb",
	"./welfare.png": "6c7f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6446";